<div class="preview" [innerHTML]='this.convertedData' (mouseup)="onTextSelect()"></div>